import React from "react";
import "@/App.css";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Packages from "./components/Packages";
import WhyUs from "./components/WhyUs";
import Services from "./components/Services";
import Gallery from "./components/Gallery";
import Testimonials from "./components/Testimonials";
import FAQ from "./components/FAQ";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import WhatsAppFloat from "./components/WhatsAppFloat";
import CallFloat from "./components/CallFloat";

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <Packages />
      <WhyUs />
      <Services />
      <Gallery />
      <Testimonials />
      <FAQ />
      <Contact />
      <Footer />
      <WhatsAppFloat />
      <CallFloat />
      <Toaster />
    </div>
  );
}

export default App;
